import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ScrollText } from "lucide-react";
import aapi, { fmtDate } from "./aapi";
import { PageHeader, EmptyState } from "@/panel/components";
import { EASE } from "@/components/Motion";

const compact = (v) => {
  if (v === null || v === undefined) return "—";
  const s = JSON.stringify(v);
  return s.length > 64 ? s.slice(0, 64) + "…" : s;
};

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    aapi.get("/audit").then(({ data }) => setLogs(data)).catch(() => setLogs([]));
  }, []);

  return (
    <div data-testid="admin-audit-page">
      <PageHeader title="Audit Log" sub="Every sensitive action, who did it, and what changed. Immutable." />

      {logs === null ? (
        <div className="flex justify-center py-24">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/20 border-t-gold" />
        </div>
      ) : logs.length === 0 ? (
        <EmptyState icon={ScrollText} title="No entries yet" sub="Admin actions will be recorded here." testid="audit-empty" />
      ) : (
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }}
          className="overflow-x-auto rounded-2xl border border-white/10" data-testid="audit-table">
          <div className="min-w-[880px]">
            <div className="grid grid-cols-12 gap-3 border-b border-white/10 bg-white/[0.02] px-5 py-3 font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-500">
              <span className="col-span-2">Time</span>
              <span className="col-span-2">Admin</span>
              <span className="col-span-2">Action</span>
              <span className="col-span-2">Target</span>
              <span className="col-span-2">Previous → New</span>
              <span className="col-span-2">IP</span>
            </div>
            {logs.map((l) => (
              <div key={l.id} data-testid={`audit-row-${l.id}`}
                className="grid grid-cols-12 items-center gap-3 border-b border-white/5 bg-panel/80 px-5 py-3 transition-colors duration-300 last:border-0 hover:bg-gold/[0.04]">
                <span className="col-span-2 font-mono text-[10px] text-neutral-500">{fmtDate(l.created_at)}</span>
                <span className="col-span-2 truncate font-mono text-xs text-gold/80">{l.admin}</span>
                <span className="col-span-2 text-xs font-semibold text-neutral-200">{l.action}</span>
                <span className="col-span-2 truncate font-mono text-xs text-neutral-400" title={l.target}>{l.target}</span>
                <span className="col-span-2 truncate font-mono text-[10px] text-neutral-500" title={`${JSON.stringify(l.previous)} → ${JSON.stringify(l.new)}`}>
                  {compact(l.previous)} → {compact(l.new)}
                </span>
                <span className="col-span-2 font-mono text-[10px] text-neutral-600">{l.ip || "—"}</span>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
}
